import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "sala-ambiente"
}
const _hoisted_2 = {
  class: "visually-hidden",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_4 = {
  class: "card",
  "aria-labelledby": "sala-identificacao-titulo"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row g-3" }
const _hoisted_7 = { class: "col-12 col-sm-4 col-lg-2" }
const _hoisted_8 = ["readonly", "aria-invalid", "aria-describedby"]
const _hoisted_9 = {
  key: 0,
  id: "sala-numero-erro",
  class: "invalid-feedback d-block"
}
const _hoisted_10 = {
  key: 1,
  id: "sala-numero-ajuda",
  class: "form-text"
}
const _hoisted_11 = { class: "col-12 col-sm-8 col-lg-4" }
const _hoisted_12 = ["readonly", "aria-invalid", "aria-describedby"]
const _hoisted_13 = {
  key: 0,
  id: "sala-bloco-erro",
  class: "invalid-feedback d-block"
}
const _hoisted_14 = {
  key: 1,
  id: "sala-bloco-ajuda",
  class: "form-text"
}
const _hoisted_15 = { class: "col-12 col-md-6 col-lg-3" }
const _hoisted_16 = { class: "col-12 col-md-6 col-lg-3" }
const _hoisted_17 = { class: "col-12 col-md-6 col-lg-3" }
const _hoisted_18 = {
  class: "card",
  "aria-labelledby": "sala-capacidade-titulo"
}
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "row g-3" }
const _hoisted_21 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_22 = ["max", "readonly", "aria-invalid", "aria-describedby"]
const _hoisted_23 = {
  key: 0,
  id: "sala-area-erro",
  class: "invalid-feedback d-block"
}
const _hoisted_24 = {
  key: 1,
  id: "sala-area-ajuda",
  class: "form-text"
}
const _hoisted_25 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_26 = ["max", "readonly", "aria-invalid", "aria-describedby"]
const _hoisted_27 = {
  key: 0,
  id: "sala-coeficiente-erro",
  class: "invalid-feedback d-block"
}
const _hoisted_28 = {
  key: 1,
  id: "sala-coeficiente-ajuda",
  class: "form-text"
}
const _hoisted_29 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_30 = ["max", "readonly", "aria-invalid", "aria-describedby"]
const _hoisted_31 = {
  key: 0,
  id: "sala-capacidade-erro",
  class: "invalid-feedback d-block"
}
const _hoisted_32 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_33 = ["max", "readonly", "aria-invalid", "aria-describedby"]
const _hoisted_34 = {
  key: 0,
  id: "sala-capacidade-real-erro",
  class: "invalid-feedback d-block"
}
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  class: "card",
  "aria-labelledby": "sala-situacao-titulo"
}
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_40 = { class: "form-check" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "form-check" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "form-check" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 1,
  class: "card",
  "aria-labelledby": "sala-documentos-titulo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccessDenied = _resolveComponent("AccessDenied")!
  const _component_BarraBotoes = _resolveComponent("BarraBotoes")!
  const _component_DropDownConsulte = _resolveComponent("DropDownConsulte")!
  const _component_AnexosAmbiente = _resolveComponent("AnexosAmbiente")!

  return (!_ctx.permissaoTela.visualizar)
    ? (_openBlock(), _createBlock(_component_AccessDenied, {
        key: 0,
        msg: "Você não tem permissão para visualizar esta tela. Caso precise de acesso, procure o suporte."
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          novalidate: "",
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.anuncio), 1),
          (_openBlock(), _createBlock(_component_BarraBotoes, {
            key: _ctx.chaveBarra,
            "loading-save": _ctx.salvando,
            "id-registro-carregado": _ctx.idCarregado,
            "grid-view-link": '/gestao/sala',
            "show-imprimir": false,
            "bloquear-botao-salvar": _ctx.somenteLeitura,
            onLimpar: _ctx.novoAmbiente,
            onExcluir: _ctx.excluir
          }, null, 8, ["loading-save", "id-registro-carregado", "bloquear-botao-salvar", "onLimpar", "onExcluir"])),
          (_ctx.carregando)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Carregando o ambiente..."))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[19] || (_cache[19] = _createElementVNode("h2", {
                id: "sala-identificacao-titulo",
                class: "h5"
              }, "Identificação e localização", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", {
                    for: "sala-numero",
                    class: "form-label"
                  }, [
                    _createTextVNode(" Identificação "),
                    _createElementVNode("span", { "aria-hidden": "true" }, "*"),
                    _createElementVNode("span", { class: "visually-hidden" }, "(obrigatório)")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-numero",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.numero) = $event)),
                    type: "text",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.numero }]),
                    maxlength: "5",
                    required: "",
                    autocomplete: "off",
                    readonly: _ctx.somenteLeitura,
                    "aria-invalid": _ctx.erros.numero ? 'true' : undefined,
                    "aria-describedby": _ctx.erros.numero ? 'sala-numero-erro' : 'sala-numero-ajuda'
                  }, null, 10, _hoisted_8), [
                    [_vModelText, _ctx.model.numero]
                  ]),
                  (_ctx.erros.numero)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.erros.numero), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, "Até 5 caracteres."))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", {
                    for: "sala-bloco",
                    class: "form-label"
                  }, [
                    _createTextVNode(" Localização "),
                    _createElementVNode("span", { "aria-hidden": "true" }, "*"),
                    _createElementVNode("span", { class: "visually-hidden" }, "(obrigatório)")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-bloco",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.bloco) = $event)),
                    type: "text",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.bloco }]),
                    maxlength: "50",
                    required: "",
                    autocomplete: "off",
                    readonly: _ctx.somenteLeitura,
                    "aria-invalid": _ctx.erros.bloco ? 'true' : undefined,
                    "aria-describedby": _ctx.erros.bloco ? 'sala-bloco-erro' : 'sala-bloco-ajuda'
                  }, null, 10, _hoisted_12), [
                    [_vModelText, _ctx.model.bloco]
                  ]),
                  (_ctx.erros.bloco)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.erros.bloco), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, " Bloco, andar, ala ou outra referência (até 50 caracteres). "))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_DropDownConsulte, {
                    id: "sala-tipo",
                    modelValue: _ctx.model.gesFuncaoOriginalId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.gesFuncaoOriginalId) = $event)),
                    modelModifiers: { number: true },
                    array: _ctx.tiposAmbiente,
                    "row-label": "texto",
                    "row-value": "valor",
                    label: "Tipo de ambiente",
                    placeholder: "Selecione o tipo",
                    disabled: _ctx.somenteLeitura
                  }, null, 8, ["modelValue", "array", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_DropDownConsulte, {
                    id: "sala-utilizacao",
                    modelValue: _ctx.model.gesUtilizacaoId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.gesUtilizacaoId) = $event)),
                    modelModifiers: { number: true },
                    array: _ctx.utilizacoes,
                    "row-label": "texto",
                    "row-value": "valor",
                    label: "Utilização atual",
                    placeholder: "Selecione a utilização",
                    disabled: _ctx.somenteLeitura
                  }, null, 8, ["modelValue", "array", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_DropDownConsulte, {
                    id: "sala-forma-ocupacao",
                    modelValue: _ctx.model.formaOcupacao,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.formaOcupacao) = $event)),
                    modelModifiers: { number: true },
                    array: _ctx.formasOcupacao,
                    "row-label": "texto",
                    "row-value": "valor",
                    label: "Forma de ocupação",
                    placeholder: "Selecione a forma",
                    disabled: _ctx.somenteLeitura
                  }, null, 8, ["modelValue", "array", "disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[25] || (_cache[25] = _createElementVNode("h2", {
                id: "sala-capacidade-titulo",
                class: "h5"
              }, "Dimensões e capacidade", -1)),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", {
                    for: "sala-area",
                    class: "form-label"
                  }, "Área (m²)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-area",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.textoArea) = $event)),
                    type: "number",
                    inputmode: "decimal",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.area }]),
                    min: "0.01",
                    max: _ctx.AREA_MAXIMA,
                    step: "0.01",
                    readonly: _ctx.somenteLeitura,
                    "aria-invalid": _ctx.erros.area ? 'true' : undefined,
                    "aria-describedby": _ctx.erros.area ? 'sala-area-erro' : 'sala-area-ajuda',
                    onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.aoMudarDimensoes && _ctx.aoMudarDimensoes(...args)))
                  }, null, 42, _hoisted_22), [
                    [_vModelText, _ctx.textoArea]
                  ]),
                  (_ctx.erros.area)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.erros.area), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, "Até duas casas decimais."))
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", {
                    for: "sala-coeficiente",
                    class: "form-label"
                  }, "Coeficiente (alunos por m²)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-coeficiente",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.textoCoeficiente) = $event)),
                    type: "number",
                    inputmode: "decimal",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.coeficienteAlunoM2 }]),
                    min: "0.0001",
                    max: _ctx.COEFICIENTE_MAXIMO,
                    step: "0.0001",
                    readonly: _ctx.somenteLeitura,
                    "aria-invalid": _ctx.erros.coeficienteAlunoM2 ? 'true' : undefined,
                    "aria-describedby": 
                  _ctx.erros.coeficienteAlunoM2 ? 'sala-coeficiente-erro' : 'sala-coeficiente-ajuda'
                ,
                    onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.aoMudarDimensoes && _ctx.aoMudarDimensoes(...args)))
                  }, null, 42, _hoisted_26), [
                    [_vModelText, _ctx.textoCoeficiente]
                  ]),
                  (_ctx.erros.coeficienteAlunoM2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.erros.coeficienteAlunoM2), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_28, " Quantos alunos cabem em cada m² (ex.: 0,8). Até quatro casas decimais. "))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", {
                    for: "sala-capacidade",
                    class: "form-label"
                  }, "Capacidade (alunos)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-capacidade",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.textoCapacidade) = $event)),
                    type: "number",
                    inputmode: "numeric",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.capacidade }]),
                    min: "0",
                    max: _ctx.CAPACIDADE_MAXIMA,
                    step: "1",
                    readonly: _ctx.somenteLeitura,
                    "aria-invalid": _ctx.erros.capacidade ? 'true' : undefined,
                    "aria-describedby": 
                  _ctx.erros.capacidade ? 'sala-capacidade-erro sala-capacidade-situacao' : 'sala-capacidade-situacao'
                ,
                    onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.aoDigitarCapacidade && _ctx.aoDigitarCapacidade(...args)))
                  }, null, 42, _hoisted_30), [
                    [_vModelText, _ctx.textoCapacidade]
                  ]),
                  (_ctx.erros.capacidade)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.erros.capacidade), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", {
                    for: "sala-capacidade-real",
                    class: "form-label"
                  }, "Capacidade real (alunos)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-capacidade-real",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.textoCapacidadeReal) = $event)),
                    type: "number",
                    inputmode: "numeric",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.erros.capacidadeReal }]),
                    min: "0",
                    max: _ctx.CAPACIDADE_MAXIMA,
                    step: "1",
                    readonly: _ctx.somenteLeitura,
                    "aria-invalid": _ctx.erros.capacidadeReal ? 'true' : undefined,
                    "aria-describedby": _ctx.erros.capacidadeReal ? 'sala-capacidade-real-erro' : undefined
                  }, null, 10, _hoisted_33), [
                    [_vModelText, _ctx.textoCapacidadeReal]
                  ]),
                  (_ctx.erros.capacidadeReal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.erros.capacidadeReal), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", {
                    id: "sala-capacidade-situacao",
                    class: _normalizeClass(["sala-capacidade-situacao", _ctx.capacidadeDiverge ? 'sala-capacidade-situacao--aviso' : '']),
                    "aria-live": "polite"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["mdi me-1", _ctx.capacidadeDiverge ? 'mdi-alert-outline' : 'mdi-calculator-variant-outline']),
                      "aria-hidden": "true"
                    }, null, 2),
                    (_ctx.capacidadeDiverge)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_36, "Capacidade ajustada manualmente."))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.textoSituacaoCapacidade), 1)
                  ], 2),
                  (_ctx.capacidadeDiverge && !_ctx.somenteLeitura)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-sm btn-outline-primary mt-2",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.usarCapacidadeCalculada && _ctx.usarCapacidadeCalculada(...args)))
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("i", {
                          class: "mdi mdi-calculator-variant-outline me-1",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createTextVNode(" Usar a capacidade calculada (" + _toDisplayString(_ctx.textoAlunos(_ctx.capacidadeCalculada ?? 0)) + ") ", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[29] || (_cache[29] = _createElementVNode("h2", {
                id: "sala-situacao-titulo",
                class: "h5"
              }, "Situação", -1)),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-recebe-turma",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.recebeTurma) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    disabled: _ctx.somenteLeitura
                  }, null, 8, _hoisted_41), [
                    [_vModelCheckbox, _ctx.recebeTurma]
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("label", {
                    for: "sala-recebe-turma",
                    class: "form-check-label"
                  }, "Recebe turma", -1))
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-requer-adequacao",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requerAdequacao) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    disabled: _ctx.somenteLeitura
                  }, null, 8, _hoisted_43), [
                    [_vModelCheckbox, _ctx.requerAdequacao]
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("label", {
                    for: "sala-requer-adequacao",
                    class: "form-check-label"
                  }, "Requer adequação", -1))
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _withDirectives(_createElementVNode("input", {
                    id: "sala-ativo",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ativo) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    disabled: _ctx.somenteLeitura
                  }, null, 8, _hoisted_45), [
                    [_vModelCheckbox, _ctx.ativo]
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("label", {
                    for: "sala-ativo",
                    class: "form-check-label"
                  }, "Ativo", -1))
                ])
              ])
            ])
          ])
        ], 32),
        (_ctx.idNumerico)
          ? (_openBlock(), _createBlock(_component_AnexosAmbiente, {
              key: 0,
              "sala-id": _ctx.idNumerico,
              "tipos-documento": _ctx.tiposDocumento
            }, null, 8, ["sala-id", "tipos-documento"]))
          : (_openBlock(), _createElementBlock("section", _hoisted_46, [...(_cache[30] || (_cache[30] = [
              _createElementVNode("div", { class: "card-body" }, [
                _createElementVNode("h2", {
                  id: "sala-documentos-titulo",
                  class: "h5"
                }, "Documentos do ambiente"),
                _createElementVNode("p", { class: "mb-0" }, "Salve o ambiente para anexar documentos a ele.")
              ], -1)
            ]))]))
      ]))
}